import { config } from '../config';

export const redirectToUrl = (sessionId: string, isMfaScope?: boolean) => {
  if (!config.loginPageUrl) {
    return;
  }
  const loginURL = isMfaScope ? config.loginMfaPageUrl : config.loginPageUrl;
  const redirectUrl = new URL(loginURL);
  redirectUrl.searchParams.append('redirect', window.location.origin + window.location.pathname + '?sid=' + sessionId);
  return redirectUrl;
};
